ht.hideLoading = function (el) {
  if (ht.smartuishell) {
    $('#legacyLoadingDivContainer').remove();
  } else {
    $('.htcLoadingDiv').remove();
  }
};
